module.exports = __webpack_public_path__ + "img/blissfulness.8d4d5b8f.png";